import { ApiError } from '@shared/api-utils';

const HTTP_TOO_MANY_REQUESTS = 429;

const VERIFICATION_BUSINESS_ERROR_STATUSES = new Set([400, 401, 422]);

function isAbortError(error: unknown): boolean {
  if (error instanceof DOMException && error.name === 'AbortError') {
    return true;
  }
  if (error instanceof Error && error.name === 'AbortError') {
    return true;
  }
  return false;
}

function isVerificationRateLimitError(error: unknown): boolean {
  if (error instanceof ApiError) {
    return error.getStatus() === HTTP_TOO_MANY_REQUESTS;
  }

  return false;
}

/** True for server/network/timeout failures — not wrong OTP or validation responses. */
function isVerificationTechnicalError(error: unknown): boolean {
  if (isVerificationRateLimitError(error)) {
    return false;
  }

  if (isAbortError(error)) {
    return true;
  }

  if (error instanceof ApiError) {
    const status = error.getStatus();
    if (VERIFICATION_BUSINESS_ERROR_STATUSES.has(status)) {
      return false;
    }
    if (status === 0 || status >= 500) {
      return true;
    }
    return false;
  }

  return true;
}

type ResolveVerificationMutationFailureHandlers = {
  onRateLimit?: () => void;
  onTechnical: () => void;
  onBusiness: () => void;
};

function resolveVerificationMutationFailure(error: unknown, handlers: ResolveVerificationMutationFailureHandlers): void {
  if (isVerificationRateLimitError(error)) {
    handlers.onRateLimit?.();
    return;
  }

  if (isVerificationTechnicalError(error)) {
    handlers.onTechnical();
    return;
  }

  handlers.onBusiness();
}

export { HTTP_TOO_MANY_REQUESTS, isVerificationRateLimitError, isVerificationTechnicalError, resolveVerificationMutationFailure };
